export const connectors = ["postgres", "snowflake", "ms_fabric_sql", "bigquery"];
export type ConnectorType = (typeof connectors)[number];

export interface DataConnector<T> {
  name: string;
  description: string;
  config: T;
}

export interface PostgresConfig {
  type: "postgres";
  host: string;
  port: string;
  database: string;
  username: string;
  password: string;
}

export interface SnowflakeConfig {
  type: "snowflake";
  account: string;
  username: string;
  privateKey: string;
  database: string;
  warehouse: string;
  passphrase: string;
}

export interface MicrosoftFabricSQLEndpointConfig {
  type: "ms_fabric_sql";
  db_name: string;
  server_url: string;
  client_id: string;
  client_secret: string;
  tenant_id: string;
}

export interface BigQueryConfig {
  type: "bigquery";
  projectId: string;
  location: string;
  serviceAccountConfig: string;
}

export type ConnectorConfig = PostgresConfig | SnowflakeConfig | MicrosoftFabricSQLEndpointConfig | BigQueryConfig;

export interface ConnectorConfigMapping {
  postgres: PostgresConfig;
  snowflake: SnowflakeConfig;
  ms_fabric_sql: MicrosoftFabricSQLEndpointConfig;
  bigquery: BigQueryConfig;
}
